import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatOptionSelectionChange } from '@angular/material/core'
import { Observable } from 'rxjs'

interface GroupedOptions {
  groupName: string
  options: any[]
}

@Component({
  selector: 'gb-select-form-field',
  templateUrl: './gb-select-form-field.component.html',
  styleUrls: ['./gb-select-form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbSelectFormFieldComponent {
  @Input() control: any
  @Input({ required: true }) labelTranslateKey!: string
  @Input() hintTranslateKey?: string | null
  @Input() hintTemplate?: boolean
  @Input() options$?: Observable<any[]>
  @Input({ required: true }) valueProperty!: string
  @Input({ required: true }) displayProperty!: string
  @Input() multiSelect: boolean = false
  @Input() groupedOptions$?: Observable<GroupedOptions[]>

  @Output() onOptionSelected = new EventEmitter<any>()

  emitSelectedOption(event: MatOptionSelectionChange, selectedOption: any) {
    if (event.isUserInput) {
      this.onOptionSelected.emit(selectedOption)
    }
  }
}
